import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import DataEngineeringPage from "./pages/DataEngineeringPage";
import CloudEngineeringPage from "./pages/CloudEngineeringPage";
import AIServicesPage from "./pages/AIServicesPage";
import TalentPodsPage from "./pages/TalentPodsPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/data-engineering" element={<DataEngineeringPage />} />
            <Route path="/cloud-engineering" element={<CloudEngineeringPage />} />
            <Route path="/ai-services" element={<AIServicesPage />} />
            <Route path="/talent-pods" element={<TalentPodsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
